module.exports = {
    online_crossing: ['线上跨境电商', 'Online Cross-Border E-Commerce'],
    online1: ['具备线上网站/平台；销售跨境商品或服务；', 'With online website/platform; sells cross-border goods or services;'],
    online2: ['出口卖家或境内对外供应商付款；', 'payment by export sellers or domestic overseas suppliers;'],
    online3: ['向海关推送报关；', 'submit customs declaration;'],
    offline_crossing: ['传统线下跨境', 'Traditional Offline Cross-Border'],
    offline1: ['一般传统跨境贸易；', 'General traditional cross-Border trade;'],
    offline2: ['出口卖家或境内对外供应商付款；', 'payment by export sellers or domestic overseas suppliers;'],
    offline3: ['向海关推送报关；', 'submit customs declaration;'],
    overseas_crossing: ['海外跨境同业', 'Overseas Cross-Border Financial Peers'],
    overseas1: ['具备境外持牌金融资质；', 'With overseas licensed financial qualifications;'],
    overseas2: ['需要同国内持牌机构进行跨境业务合作；', 'need to conduct cross-border business coop. with domestic licensed institutions;'],
    proxy_crossing: ['跨境代理', 'Cross-Border Agent'],
    proxy1: ['具有丰富的跨境商户资源；', 'With abundant cross-border merchant resources;'],
    proxy2: ['可快速拓展业务发展；', 'enables rapid business expansion;'],
    person_crossing: ['个人跨境', 'Personal Cross-Border'],
    person1: ['境内个人出口卖家；', 'Domestic individual export sellers;'],
    person2: ['境内需向境外支付服贸费用缴纳；', 'domestic payment of trade in services fees to overseas;'],
    collect_crossing: ['境外收单', 'Overseas Acquiring'],
    collect1: ['境内出口卖家；', 'domestic export sellers;'],
    collect2: ['将资金从境外购买方收取并；', 'collect funds from overseas buyers and settle;'],
    collect3: ['结算到卖家账户；', 'funds to sellers accounts;'],
    audit: {
        privacyPolicy: ['跨境支付业务系统隐私政策', 'Privacy policy of cross-border payment business system'],
        h1: ['认证资料审核中，请耐心等待', 'Authentication materials under review, please wait patiently'],
        button1: ['立即下载', 'download'],
        button2: ['立即上传', 'upload'],
        p1: ['为了保障审核通过，易生将于1-3个工作日内安排客户经理联系-', 'To ensure successful review, EasePay will arrange manager to contact you within 1-3 working days-'],
        p2: ['-沟通审核及业务开通事宜，其中将会根据所开通的业务，补充涉及所需材料，请留意接听电话/查看邮件。', ' -discuss review & business activation. Materials required will be requested based on the business to be activated. Please note to answer calls/check emails.'],
        errorMsg: ['失败原因', 'failure'],
        button3: ['立即修改', 'modify'],
        uploadDialogVisible: ['上传盖章合同', 'upload stamped contract'],
        closeUploadDialog: ['取 消', 'cancel'],
        confirmUpload: ['确认上传', 'confirm upload'],
        message1: ['合同上传成功～', 'contract upload succeeded～'],
        message2: ['请上传盖章合同～', 'please upload the stamped contract～'],
    },
    step: {
        switchEntity: ['更换认证主体', 'Change authentication entity'],
        p1: ['根据监管相关要求，结合您所开通的业务，请按如下步骤如实填写相关信息，以便顺利通过审核。', 'In accordance with relevant regulatory requirements and combined with the business you are activating, please fill in the relevant information truthfully in the following steps to ensure successful review.'],
        tab1: ['基本信息', 'basic info.'],
        tab2: ['法定代表人股东信息', 'legal rep. & shareholder info.'],
        tab3: ['银行发票信息', 'bank & invoice info.'],
        tab4: ['业务信息', 'business info.'],
        tab5: ['调查信息', 'survey info.'],
        longTerm: ['长期', 'long-term'],
    },
    step1: {
        invitation: ['邀请码：', 'invitation code:'],
        noInvitation: ['无邀请码，可为空', 'no invitation code, optional'],
        invalidInvitation: ['邀请码无效，请确认后重输', 'invalid invitation code, please confirm and re-enter'],
        customer: ['客户经理邀请码：', 'account manager invitation code'],
        noCustomer: ['无专属客户经理邀请码，可为空', 'no dedicated account manager invitation code, optional'],
        invalidNoCustomer: ['专属客户经理邀请码无效，请确认后重输', 'invalid dedicated account manager invitation code, please confirm and re-enter'],
        sfz: ['身份证照：', 'ID card photo:'],
        upSfzZ: ['请上传身份证正面', 'upload the front of ID card'],
        sfzZ: ['身份证正面', 'front of ID Card'],
        upSfzB: ['请上传身份证背面', 'upload the back of ID card'],
        sfzB: ['身份证背面', 'back of ID card'],
        upSfzSC: ['请上传手持身份证', 'upload the photo of holding ID card'],
        sfzSC: ['手持身份证', 'photo of holding ID card'],
        prompt: ['图片格式为：.jpg和.png；图片大小不得超过1M;', 'Image format: .jpg&.png; image size ≤ 1M;'],
        name: ['真实姓名：', 'real name'],
        nameZJ: ['证件上的姓名', 'name on ID card'],
        code: ['身份证号', 'ID No.'],
        scopeTime: ['身份证有效期：', 'ID validity period:'],
        start: ['开始日期', 'start date'],
        zhi: ['至', 'to'],
        end: ['结束日期', 'end date'],
        address: ['常住地址', 'permanent residence addr.'],
        zhName: ['企业名称', 'enterprise name '],
        emgName: ['英文名称', 'english name'],
        country: ['企业注册地址', 'enterprise registration addr.'],
        originCountry: ['所属国家', 'origin country'],
        registerAddress: ['详细地址', 'detailed addr.'],
        provinceDz: ['企业注册地址', 'enterprise registration addr.'],
        province: ['省份', 'province'],
        city: ['城市', 'city'],
        registerAddress1: ['区/县、街道', 'district / county, street'],
        registerAddress2: ['建筑物名称、楼层编号', 'buliding name'],
        industryAttribute: ['行业属性', 'industry attribute'],
        registerPost: ['邮政编码', 'postal code'],
        economyType: ['经济类型', 'economic type'],
        foreignInvestorCountryCode: ['外方投资者国别代码', 'foreign investor country code'],
        registerTime: ['企业注册时间', 'register time'],
        selectDate: ['选择日期', 'select date'],
        merchantLicenseType: ['公司证件类型', 'co.document type '],
        businessLicenseNumber: ['公司证件号', 'co.document no.'],
        blPeriodOfValidityFrom: ['营业执照有效期', 'bus. lic. validity period'],
        yymmdd: ['yyyy-mm-dd 或长期', 'yyyy-mm-dd or long-term'],
        organizationInstitutions: ['组织机构号', 'organization code'],
        registeredFund: ['注册资金', 'registered fund'],
        registerUnit: ['单位', 'unit'],
        operateScope: ['经营范围：', 'business scope：'],
        natureOffice: ['办公室房屋产权性质', 'office property right nature'],
        areaOffice: ['经营地址面积', 'address area'],
        pfm: ['平方米', 'square meter'],
        businessLicenseImage: ['营业执照', 'bus. license'],
        ts1: ['图片格式为：.jpg和.png；图片大小不得超过1M；', 'image format: .jpg &.png; image size ≤ 1M;'],
        ts2: ['图片格式为：.jpg、.png和.pdf；图片大小不得超过5M；', 'image format:.jpg,.png&.pdf;image size ≤ 5M;'],
        upBusinessLicenseImage: ['上传营业执照', 'upload bus. license'],
        leaseContractId: ['租赁合同：', 'lease contract'],
        ts3: ['拼接成一张图片上传；图片格式为：.jpg、.png和.pdf；图片大小不得超过5M；', 'splice into one image for upload; image format: .jpg, .png&.pdf; image size ≤ 5M;'],
        upLeaseContractId: ['上传租赁合同', 'upload lease contract'],
        goBack: ['返回', 'back'],
        goNext: ['下一步', 'next'],
        ts11: ['身份证上传成功～', 'ID card uploaded successfully~'],
        ts12: ['身份证识别失败～', 'ID card recognition failed~'],
        ts13: ['身份证已过期～', 'My ID card has expired~'],
        ts14: ['营业执照已过期～', 'The business license has expired~'],
        ziyong: ['自用', 'for personal use'],
        zuyong: ['租用', 'rent'],

        platformSelfDtos_name: ['官网名称：', 'platform website name:'],
        platformSelfDtos_name_placeholder: ['官网名称', 'ec platform name'],
        platformSelfDtos_websiteAddress: ['官网地址：', 'platform website addr.:'],
        platformSelfDtos_websiteAddress_placeholder: ['官网地址', 'ec platform website URL'],
        platformSelfDtos_websiteIcpRecord_placeholder: ['官网 ICP 备案号', 'platform website ICP reg. No.'],
    },
    step2: {
        operatorIsLegal: ['您是否为法定代表人：', 'Are you the legal representative:'],
        yes: ['是', 'yes'],
        no: ['否', 'no'],
        statutory: ['法定代表人证件照：', 'legal rep. ID photo:'],
        handler: ['经办人证件照：', 'handler ID photo:'],
        identityFrontImage: ['请上传证件正面', 'upload the front of ID'],
        identityFrontImageZM: ['证件正面', 'front of ID'],
        identityBackImage: ['请上传证件背面', 'upload the back of ID'],
        identityBackImageBM: ['证件背面', 'back of ID'],
        identityInHandImage: ['请上传手持证件或盖章复印件', 'upload the photo of holding ID or sealed copy'],
        identityInHandImageSC: ['手持证件或盖章复印件', 'photo of holding ID or sealed copy'],
        identityFrontImage1: ['请上传证件正反面的图片', 'upload photos of the front & back of ID'],
        identityFrontImage1ZFM: ['证件正反面存为一张图片上传', 'Save the front & back of ID as one image for upload'],
        nameLegal: ['法定代表人姓名', 'legal rep. name'],
        nameLegalPlaceholder: ['证件上的姓名', 'name on ID card'],
        nameHandler: ['经办人姓名', 'handler name'],
        nameHandlerPlaceholder: ['证件上的姓名', 'name on ID card'],
        engLegalName: ['请填写法定代表人姓名拼音', 'fill in the legal rep. name in Pinyin'],
        engLegalNamePlaceholder: ['姓名拼音', 'name in pinyin'],
        phoneLegal: ['法定代表人联系方式', 'legal rep. contact info.'],
        phoneHandler: ['经办人联系方式', 'handler contact info.'],
        phonePlaceholder: ['联系方式', 'contact info.'],
        identityTypeLegal: ['法定代表人证件类型', 'legal rep. ID type'],
        identityTypeHandler: ['经办人证件类型', 'handler ID type'],
        identityTypePlaceholder: ['证件类型', 'ID type'],
        identityLegal: ['法定代表人证件号', 'legal rep. ID NO.'],
        identityHandler: ['经办人证件号', 'handler ID NO.'],
        identityPlaceholder: ['证件号', 'ID NO.'],
        scopeTime: ['证件有效期：', 'ID validity period:'],
        scopeTimePlaceholder: ['请选择证件有效期', 'select ID validity period'],
        eMailLegal: ['法定代表人邮箱：', 'legal rep. email:'],
        eMailHandler: ['经办人邮箱：', 'handler email:'],
        eMailPlaceholder: ['邮箱地址', 'email addr.'],
        codePlaceholder: ['邮政编码', 'postal code'],
        provinceLegal: ['法定代表人地址：', 'legal rep. addr.:'],
        ssProvince: ['请选择所属省份', 'Please select the province'],
        provinceHandler: ['经办人地址：', 'handler addr.'],
        provincePlaceholder: ['省份', 'province'],
        xzCity: ['请选择所属城市', 'Please select the city of residence'],
        city: ['城市', 'city'],
        address: ['详细地址', 'detailed addr.'],
        ywsf: ['英文省份', 'English provinces'],
        ywcs: ['英文城市', 'English city'],
        shareholders25: ['是否有其他持股≥25%股东：', 'Are there any other shareholders holding 25% or more of the shares:'],
        shareholdersType: ['股东类型：', 'shareholder type:'],
        shareholdersTypeOption1: ['自然人股东（个人）', 'individual shareholder (personal)'],
        shareholdersTypeOption2: ['法人股东（企业）', 'corporate shareholder (enterprise)'],
        gdsfzz: ['股东身份证照：', 'Shareholder ID card:'],
        shareholdersName: ['股东姓名：', 'shareholder name:'],
        shareholdersNamePlaceholder: ['证件上的姓名', 'name on ID card'],
        percentage: ['股东股份占比：', 'shareholder shareholding ratio:'],
        percentagePlaceholder: ['股份占比', 'shareholding ratio'],
        businessLicenseImageUrl: ['营业执照：', 'bus. license'],
        businessLicenseImageUrlPlaceholder: ['上传营业执照', 'upload bus. license'],
        socialCreditCodePlaceholder: ['统一社会信用代码', 'unified social credit ID code'],
        shareholdersIdentityFrontImage: ['请上传身份证正面', 'upload the front of ID card'],
        shareholdersIdentityBackImage: ['请上传身份证背面', 'upload the back of ID card'],
        sfztpsc: ['身份证图片上传', 'Upload ID card image'],
        sfzyz: ['身份证正反面存为一张图片上传', 'Save the front and back of the ID card as one picture and upload it'],
        shareholdersScopeTime: ['股东证件有效期', 'ID validity period'],
        shareholdersIdentity: ['股东身份证号', 'ID NO.'],
        shareholdersIdentityPlaceholder: ['身份证号', 'ID NO.'],
        dateRangeSeparator: ['至', 'to'],
        startDate: ['开始日期', 'start date'],
        endDate: ['结束日期', 'end start'],
        imageFormatTip1: ['图片格式为：.jpg和.png；图片大小不得超过1M；', 'image format: .jpg &.png; image size ≤ 1M;'],
        imageFormatTip2: ['图片格式为：.jpg、.png和.pdf；图片大小不得超过5M；', 'image format:.jpg,.png&.pdf;image size ≤ 5M;'],
        shareholdersTip: ['根据人行235号文要求，请如实填写直接或间接拥比例≥25%认证企业股权或表决权的股东信息，涉及多层股东的需穿透2层。', 'In accordance with the requirements of PBC Circular No. 235, please truthfully fill in info. of shareholders with direct/indirect ≥25% equity or voting rights in the certified enterprise. For multi-layer shareholders, penetration up to 2 layers is required.'],
        multiShareholdersTip: ['若有多个股东信息，请逐个添加', 'If there are multiple shareholders, please add them one by one'],
        addShareholderBtn: ['添加股东', 'add'],
        deleteBtn: ['删除', 'delete'],
        prevStepBtn: ['上一步', 'previous'],
        shareholderName: ['请填写股东姓名', 'Please fill in the name of the shareholder'],
        ts1: ['身份证上传成功～', 'ID card uploaded successfully~'],
        ts2: ['身份证识别失败～', 'ID card recognition failed~'],
        ts3: ['身份证已过期～', 'My ID card has expired~'],
        fdAddress: ['法定代表人地址信息', 'Legal Entity Address Information'],
        isLegal: ['控股人是否为法人:', 'Ctrl. Person Legal:'],
        kgName: ['控股人名称', 'Ctrl. Person Name'],
        kgType: ['控股人证件类型：', 'Ctrl. Person ID Type'],
        gdCode: ['控股人证件号', 'Ctrl. Person ID No.'],
        codeNum: ['证件号', 'ID No.'],
        gdTime: ['控股人证件有效期', 'Ctrl. Person ID Validity'],
        gdAddress: ['控股人地址', 'Ctrl. Person Addr.'],
        gdAmount: ['控股人出资金额', 'Ctrl. Person Contrib. Amt.'],
        gdAmountTime: ['控股人出资日期', 'Ctrl. Person Contrib. Date'],
        gdgqbl: ['控股人股权比例', 'Ctrl. Person Eq. Ratio'],
    },
    step3: {
        accountLocation: ['账户地点：', 'account location:'],
        locationInternal: ['境内', 'domestic'],
        locationForeign: ['境外', 'overseas'],
        foreignAccountName: ['企业银行账户', 'enterprise bank acct.'],
        foreignAccountNo: ['企业银行账号', 'enterprise bank acct. No.'],
        foreignBankName: ['开户行名称', 'issuing bank name'],
        currency: ['开户币种', 'account opening currency'],
        bankLocation: ['开户行所在地：', 'bank location:'],
        country: ['国家', 'country'],
        province: ['省份', 'province'],
        city: ['城市', 'city'],
        bankCode: ['开户银行编号', 'issuing bank code'],
        internalAccountName: ['企业银行账户：', 'enterprise bank acct.:'],
        internalAccountNo: ['企业银行账号：', 'enterprise bank acct. No.:'],
        internalBankName: ['开户行名称：', 'issuing bank name:'],
        internalBankCode: ['开户行行号：', 'issuing bank No.：'],
        internalBankCode2: ['开户行行号', 'issuing bank No.'],
        bankMaterial: ['银行户材料：', 'bank material:'],
        uploadTips1: ['上传银行账户材料的原件照片或加盖公章的复印件，二选一：', 'Upload either original photo of bank acct. document or sealed copy:'],
        uploadTips2: ['（1）企业开户许可证；', '(1) Enterprise Acct. Opening Permit;'],
        uploadTips3: ['（2）本企业名称的《基本存款账户信息》；', '(2) "Basic Deposit Acct. Info." in the enterprise name;'],
        uploadFormat1: ['（3）图片格式为：.jpg和.png；图片大小不得超过1M；', 'image format: .jpg &.png; image size ≤ 1M;'],
        uploadFormat2: ['（3）图片格式为：.jpg、.png和.pdf；图片大小不得超过5M；', 'image format:.jpg,.png&.pdf;image size ≤ 5M;'],
        personalBankNo: ['银行卡号：', 'bank NO.:'],
        personalBankName: ['银行名称：', 'bank name:'],
        contactMethod: ['邮箱：', 'email:'],
        phone: ['手机号：', 'phone:'],
        verificationCode: ['验证码：', 'verification code:'],
        nextStepBtn: ['下一步', 'next'],
        submitBtn: ['提交', 'submit'],
        ts1: ['请检查手机号是否填写正确', 'Please check if the phone number is filled in correctly'],
        ts2: ['请填写手机号', 'Please provide your phone number'],
        ts3: ['信息不匹配', 'Information mismatch'],
    },
    step4: {
        existCustomsDeclarationBusiness: ['是否有报关业务：', 'exist customs decl. business:'],
        firmCustomsRecordNumber_placeholder: ['企业海关备案号', 'enterprise customs reg. No.'],
        ecCheckoutQuarantineCode: ['电商企业检验检疫代码：', 'ec enterprise insp.&quar. code:'],
        ecCheckoutQuarantineCode_placeholder: ['检验检疫代码', 'insp.&quar. code'],
        ecPlatformName_placeholder: ['电商平台名称', 'ec platform name'],
        ecPlatformCode_placeholder: ['电商平台代码', 'ec platform code'],
        isSpecialEconomyType: ['是否特殊经济区企业：', 'is it a special economic type:'],
        specialEconomyType_placeholder: ['特殊经济区类型', 'special economic type'],
        subject: ['电商主体：', 'ec entity:'],
        subject_self: ['自有平台', 'self-owned platform'],
        subject_wechatMini: ['小程序', 'mini program'],
        subject_wechat: ['公众号', 'official account'],
        subject_settled: ['入驻型平台', 'settled platform'],
        platformSelfDtos_name: ['平台网站名称：', 'platform website name:'],
        platformSelfDtos_name_placeholder: ['电商平台名称', 'ec platform name'],
        platformSelfDtos_websiteAddress: ['平台网址：', 'platform website addr.:'],
        platformSelfDtos_websiteAddress_placeholder: ['电商平台网址', 'ec platform website URL'],
        platformSelfDtos_websiteIcpRecord_placeholder: ['平台网站ICP备案号', 'platform website ICP reg. No.'],
        platformSelfDtos_websiteSecurityRecord: ['平台网站网安备案号：', 'platform website cybersec. reg. No.:'],
        platformSelfDtos_websiteSecurityRecord_placeholder: ['网站网安备案号', 'website cybersec. reg. No.'],
        wechatMiniProgram_name_placeholder: ['小程序名称', 'mini program name'],
        wechatMiniProgram_code: ['APPID', 'APPID'],
        wechatMiniProgram_code_placeholder: ['小程序APPID', 'mini program APPID'],
        wechatMiniProgram_ztName: ['主体名称', 'entity name'],
        webchatDtos_name: ['公众号名称', 'official account name'],
        webchatDtos_code: ['APPID', 'APPID'],
        webchatDtos_code_placeholder: ['公众号APPID', 'official account APPID'],
        webchatDtos_authPath: ['授权目录', 'auth. directory'],
        webchatDtos_authPath_placeholder: ['公众号授权目录', 'official account auth. directory'],
        platformDtos_name: ['入驻平台主体名称', 'settled platform entity name'],
        platformDtos_name_placeholder: ['国内店铺名称', 'domestic store name'],
        platformDtos_shopWebsiteAddress: ['入驻平台网址：', 'settled platform website URL:'],
        platformDtos_shopWebsiteAddress_placeholder: ['店铺首页网址', 'store homepage URL'],
        documentDtos: ['证明材料：', 'supporting document:'],
        documentDtos_tips: ['图片格式为：.jpg和.png；图片大小不得超过1M；', 'image format: .jpg &.png; image size ≤ 1M;'],
        materialDescription: ['材料说明', 'document description'],
        addWechatMiniBtn: ['添加小程序', 'add mini program'],
        deleteBtn: ['删除', 'delete'],
        addWechatBtn: ['添加公众号', 'add official account'],
        addPlateformBtn: ['添加平台', 'add platform'],
        ts1: ['公众号和小程序总数不能超过5个！', 'The total number of official account and applets cannot exceed 5!'],
        dszt: ['请选择电商主体', 'Please select the e-commerce entity'],
        wzmc: ['请填写平台网站名称', 'Please fill in the platform website name'],
        ptwz: ['平台网站名称长度不大于9个汉字或18个英文', 'The length of the platform website name should not exceed 9 Chinese characters or 18 English characters'],
        xcxztzm: ['小程序主体证明', 'Mini Program Entity Certificate'],
        gzhztzm: ['公众号主体证明', 'Subject certification of official account'],
    },
    step5: {
        isSpecialEconomyType: ['是否特殊经济区企业：', 'is it a special economic type:'],
        isSpecialEconomyType_yes: ['是', 'yes'],
        isSpecialEconomyType_no: ['否', 'no'],
        specialEconomyType: ['特殊经济区类型：', 'special economic type:'],
        specialEconomyType_placeholder: ['特殊经济区类型', 'special economic type'],
        platformUrl: ['平台网站URL：', 'platform website URL:'],
        platformUrl_placeholder: ['平台网站URL', 'platform website URL'],
        platformIp: ['平台网站IP地址：', 'platform website IP:'],
        platformIp_placeholder: ['平台网站IP地址', 'platform website IP'],
        transUrl: ['交易网站URL', 'transaction website URL'],
        transUrl_placeholder: ['交易网站URL', 'transaction website URL'],
        appId: ['APPID：', 'APPID:'],
        appId_placeholder: ['APPID', 'APPID'],
        appId_tip: ['多个APPID请用分号进行分隔', 'separate multiple APPIDs with semicolons'],
        singleMaxAmount: ['单笔最高交易额：', 'single max amt:'],
        singleMaxAmount_placeholder: ['单笔最高交易额', 'single max amt'],
        singleMinAmount: ['单笔最低交易额：', 'single mini amt:'],
        singleMinAmount_placeholder: ['单笔最低交易额', 'single mini amt'],
        dayMaxAmount: ['日最高交易额：', 'daily max amt:'],
        dayMaxAmount_placeholder: ['日最高交易额', 'daily max amt'],
        dayMinAmount: ['日最低交易额：', 'daily mini amt:'],
        dayMinAmount_placeholder: ['日最低交易额', 'daily mini amt'],
        dayMaxNumber: ['日最高交易笔数：', 'daily max NO.:'],
        dayMaxNumber_placeholder: ['日最高交易笔数', 'daily max NO.'],
        dayMinNumber: ['日最低交易笔数：', 'daily mini NO.:'],
        dayMinNumber_placeholder: ['日最低交易笔数', 'daily mini NO.'],
        monthMaxAmount: ['月最高交易额：', 'month max amt:'],
        monthMaxAmount_placeholder: ['月最高交易额', 'month max amt'],
        monthMinAmount: ['月最低交易额：', 'month mini amt:'],
        monthMinAmount_placeholder: ['月最低交易额', 'month mini amt'],
        monthMaxNumber: ['月最高交易笔数：', 'month max NO.:'],
        monthMaxNumber_placeholder: ['月最高交易笔数', 'month max NO.'],
        monthMinNumber: ['月最低交易笔数：', 'month mini NO.:'],
        monthMinNumber_placeholder: ['月最低交易笔数', 'month mini NO.'],
        monthAverNumber: ['月均交易笔数：', 'month avg NO.:'],
        monthAverNumber_placeholder: ['月均交易笔数', 'month avg NO.'],
        monthAverAmount: ['月均交易金额：', 'month avg amt:'],
        monthAverAmount_placeholder: ['月均交易金额', 'month avg amt'],
        yearMax: ['年度内销量最高的月份：', 'month max sales in a year:'],
        yearMax_placeholder: ['例：1月，2月，3月（三个内）', 'ex: Jan., Feb., Mar. (within 3 months)'],
        yearMin: ['年度内销量最低的月份：', 'month mini sales in a year:'],
        yearMin_placeholder: ['例：1月，2月，3月（三个内）', 'ex: Jan., Feb., Mar. (within 3 months)'],
        monthRefuseNumber: ['月平均拒付笔数：', 'month avg chargeback NO.:'],
        monthRefuseNumber_placeholder: ['月平均拒付笔数', 'month avg chargeback NO.'],
        monthRefuseAmount: ['月平均拒付金额：', 'month avg chargeback amt:'],
        monthRefuseAmount_placeholder: ['月平均拒付金额', 'month avg chargeback amt'],
        monthRefundNumber: ['月平均退款笔数：', 'month avg refund NO.:'],
        monthRefundNumber_placeholder: ['月平均退款笔数', 'month avg refund NO.'],
        monthRefundAmount: ['月平均退款金额：', 'month avg refund amt:'],
        monthRefundAmount_placeholder: ['月平均退款金额', 'month avg refund amt'],
        yearBeforeAmount: ['前一年营业额：', 'previous year amt:'],
        yearBeforeAmount_placeholder: ['前一年营业额', 'previous year amt'],
        dbaName: ['DBA名称（账单名称）：', 'DBA Name (billing name):'],
        dbaName_placeholder: ['DBA名称（账单名称）', 'DBA Name (billing name)'],
        mcc: ['MCC：', 'MCC:'],
        mcc_placeholder: ['MCC', 'MCC'],
        recordIcpInfo: ['网站ICP备案信息：', 'web ICP reg.info.:'],
        recordIcpInfo_placeholder: ['网站ICP备案信息', 'web ICP reg.info.'],
        recordInfo: ['网安备案信息/备案号：', 'cybersec.reg.info./reg.No.:'],
        recordInfo_placeholder: ['网安备案信息/备案号', 'cybersec.reg.info./reg.No.'],
        document: ['证明材料：', 'supporting document:'],
        document_tips: ['图片格式为：.jpg、.png和.pdf；图片大小不得超过5M；', 'image format:.jpg,.png&.pdf;image size ≤ 5M;'],
        materialDescription: ['材料说明', 'document description'],
        webHome: ['网站主页截图', 'screenshot of web homepage'],
        webContact: ['网站联系方式页面截图', 'screenshot of web contact page'],
        webReturn: ['网站退换货及配送说明页面截图', 'screenshot of web return & shipping policy page'],
        webPay: ['网站商品支付页面截图', 'screenshot of web product payment page'],
        office: ['办公场所(门头、场内、库房合为一张图)', 'office premises (combine entrance, interior, warehouse into one image)'],
        recentWaybill: ['近期运单截图', 'screenshot of recent shipping document'],
        domainCert: ['域名证书', 'domain cert.'],
        riskDetection: ['EC和Austreme的风险检测报告', 'EC and Austreme risk assessment reports'],
        matchResult: ['MATCH扫描结果截图', 'screenshot of MATCH scan results'],
        pastTrans: ['过往交易纪录及拒付、退款比例', 'historical trans. records & chargeback/refund ratios'],
        specialIndustry: ['特殊行业许可证书(选填)', 'special industry permit (optional)'],
        addOverseasWebsiteBtn: ['添加交易网站', 'add trans. web'],
        deleteBtn: ['删除', 'delete'],
    },
    step6: {
        XZKZ: ['请选择卡种', 'Please select the type of card'],
        rejectionRate: ['拒付率', 'chargeback rate'],
        fraudRate: ['欺诈率', 'fraud rate'],
        refundRate: ['退款比率', 'refund rate'],
        sdjy: ['收单经验：', 'Acquiring experience：'],
        sdxs: ['目前支持的收单形式：', 'Currently supported forms of acquiring:'],
        online: ['线上', 'online'],
        offline: ['线下', 'offline'],
        cnyExperience: ['人民币卡受理经验：', 'RMB experience:'],
        foreExperience: ['外币卡受理经验：', 'foreign experience:'],
        cnyTime: ['开始受理日期：', 'start date:'],
        cnyBank: ['原收单银行', 'previous acquiring bank'],
        foreTime: ['开始受理日期：', 'start date:'],
        foreBank: ['原收单银行：', 'previous acquiring bank:'],
        acceptCard: ['受理卡种：', 'acceptance card:'],
        jyqk: ['交易情况：', 'Transaction situation:'],
        jyqkys: ['网上交易商户是否包含以下因素：', 'Does the online transaction merchant include the following factors:'],
        instruction: ['商品/服务说明', 'product/service desc.'],
        change: ['退换货政策', 'return&refund policy'],
        legal: ['法律限制', 'legal restriction'],
        shipping: ['送货政策', 'shipping policy'],
        service: ['客服', 'CS'],
        secrecy: ['保密政策', 'privacy policy'],
        currency: ['交易货币', 'trans. currency'],
        webSite: ['网址(国家域名)', 'website(country domain) '],
        privacy: ['隐私', 'privacy'],
        country: ['商户国家/地址', 'country/address'],
        sqxfz: ['收取消费者购物款后多久消费者会收到购买物或得到相应服务：', 'How long after receiving payment from consumers will they receive their purchased goods or receive the corresponding services：'],
        one: ['24小时-5天', '24 hours-5 days'],
        six: ['6-10天', '6-10 days'],
        eleven: ['11-20天', '11-20 days'],
        twentyOne: ['21-30天', '21-30 days'],
        moreThirty: ['30天以上', 'over 30 days'],
        shwz: ['商户网站是否包含以下服务类型：', 'Does the merchant website include the following service types:'],
        dues: ['会员会费服务', 'membership fee service'],
        subscription: ['订阅服务', 'subscription service'],
        guarantee: ['担保服务', 'guarantee service'],
        provide: ['不提供上述服务类型', 'not provide the aforementioned service types'],
        websiteSecurity: ['网站安全措施：', 'website security measures:'],
        punishment: ['是否受到卡组织惩罚：', 'penalized by card organizations:'],
        business: ['开展线上外卡收单业务的情况说明：', 'desc. of online foreign card acq. business op.:'],
        refundInfo: ['简述退换货时间与退换货政策：', 'brief desc. of return&refund timeframe and policy:'],
        have: ['有', 'have'],
        none: ['无', 'none']
    }
}
